import { Injectable } from "@angular/core";
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from "@angular/router";
import { Observable } from "rxjs";
import { AuthService } from "./services/auth.service";
import { globalStore } from "api";
@Injectable({
  providedIn: "root"
})
export class AuthGuard implements CanActivate {
  constructor(
    private auth: AuthService,
    private router: Router
  ) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (this.auth.isLoggedIn()) {
      //when the user logs in, check if there was a redirect url stored, and send them there
      redirectToLastStoredUrl();
      return true;
    } else {
      //if the user is not logged-in and we get here, store the url for a later redirect
      storeUrlForRedirect();
      this.router.navigate(["/login-cognito"], {});
      return false;
    }
  }
}

const redirectUriKey = "inblock-redirect-uri";

const redirectToLastStoredUrl = () => {
  const redirectUri = localStorage.getItem(redirectUriKey);
  if (redirectUri) {
    localStorage.removeItem(redirectUriKey);
    window.location.href = redirectUri;
  }
};

const storeUrlForRedirect = () => {
  const requestUrl = window.location.href;
  if (
    !localStorage.getItem(redirectUriKey) &&
    !requestUrl.includes("login") &&
    requestUrl.match("((.*localhost:[0-9]+[/])|(.*.inblock.com[/]))[0-9-A-z]+")
  ) {
    localStorage.setItem(redirectUriKey, requestUrl);
  }
};

@Injectable({
  providedIn: "root"
})
export class AlreadyLoggedInGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (this.auth.isLoggedIn()) {
      this.router.navigate(["/home"], {});
      return false;
    } else {
      return true;
    }
  }
}

@Injectable({
  providedIn: "root"
})
export class MustBeDistributor implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (this.auth.getUserType() === "distributor") {
      return true;
    } else {
      return false;
    }
  }
}

@Injectable({
  providedIn: "root"
})
export class UserCanAdmin implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (this.auth.canAdmin()) {
      return true;
    } else {
      return false;
    }
  }
}

@Injectable({
  providedIn: "root"
})
export class AgreedToTerms implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return true;
  }
}

@Injectable({
  providedIn: "root"
})
export class IsDistributor implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (this.auth.getUserType() === "distributor") {
      return true;
    } else {
      return false;
    }
  }
}

@Injectable({
  providedIn: "root"
})
export class IsSupplier implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (this.auth.getUserType() === "supplier") {
      return true;
    } else {
      return false;
    }
  }
}

@Injectable({
  providedIn: "root"
})
export class RedirectToOrdersIfCustomerGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (this.auth.isCustomer() || this.auth.isAdmin()) {
      this.router.navigate(["/orders"], {});
      return false;
    } else {
      return true;
    }
  }
}

@Injectable({
  providedIn: "root"
})
export class PreloadRelationships implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
      globalStore.fetchAfterLogin();
      return true;
  }
}
